import { useState } from 'react';
import ConfirmDialog from '../components/common/ConfirmDialog';



export const useConfirm = () => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'danger'
  });

  const confirm = (options) => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title: options.title || 'تأكيد',
        message: options.message,
        onConfirm: () => {
          setConfirmState(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmState(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        },
        type: options.type || 'danger'
      });
    });
  };

  const closeConfirm = () => {
    if (confirmState.onCancel) {
      confirmState.onCancel();
    } else {
      setConfirmState(prev => ({ ...prev, isOpen: false }));
    }
  };

  const ConfirmDialogComponent = () => (
    <ConfirmDialog
      isOpen={confirmState.isOpen}
      onClose={closeConfirm}
      onConfirm={confirmState.onConfirm}
      onCancel={confirmState.onCancel}
      title={confirmState.title}
      message={confirmState.message}
      type={confirmState.type}
    />
  );

  return { confirm, ConfirmDialogComponent };
};
